import { LocaleId, TranslationDictionaryMapping } from '@domgen/dgx-fe-i18n';
import { FeaturePaymentMethodTranslationDictionary } from '@checkout/util-models';

export const translation: TranslationDictionaryMapping<FeaturePaymentMethodTranslationDictionary> =
  {
    [LocaleId.English_GreatBritain]: {
      PAYMENT_METHOD_CREDIT_CARD_OPTION_LABEL: 'Credit card',
      PAYMENT_METHOD_DIRECT_DEBIT__HIGHLIGHTED_TEXT:
        'Includes {{ discount }} Direct Debit Discount',
      PAYMENT_METHOD_DIRECT_DEBIT_OPTION_LABEL: 'Direct debit',
      PAYMENT_METHOD_ERROR_REQUIRED: 'Please select a payment method',
      PAYMENT_METHOD_FORM_SUBMIT_BUTTON: 'Continue to payment details',
      PAYMENT_METHOD_LABEL: 'Select your payment method',
      PAYMENT_METHOD_MONTHLY_LABEL: '12 monthly payments of {{ value }}',
      PAYMENT_METHOD_ONE_OFF_LABEL: 'One-time payment of {{ value }}',
      PAYMENT_METHOD_TOTAL_COST: 'Total cost: {{ value }}',
    },
    [LocaleId.English_Ireland]: {
      PAYMENT_METHOD_CREDIT_CARD_OPTION_LABEL: 'Credit card',
      PAYMENT_METHOD_DIRECT_DEBIT__HIGHLIGHTED_TEXT:
        'Includes {{ discount }} Direct Debit Discount',
      PAYMENT_METHOD_DIRECT_DEBIT_OPTION_LABEL: 'Direct debit',
      PAYMENT_METHOD_ERROR_REQUIRED: 'Please select a payment method',
      PAYMENT_METHOD_FORM_SUBMIT_BUTTON: 'Continue to payment details',
      PAYMENT_METHOD_LABEL: 'Select your payment method',
      PAYMENT_METHOD_MONTHLY_LABEL: '12 monthly payments of {{ value }}',
      PAYMENT_METHOD_ONE_OFF_LABEL: 'One-time payment of {{ value }}',
      PAYMENT_METHOD_TOTAL_COST: 'Total cost: {{ value }}',
    },
    [LocaleId.English_US]: {
      PAYMENT_METHOD_CREDIT_CARD_OPTION_LABEL: 'Credit card',
      PAYMENT_METHOD_DIRECT_DEBIT__HIGHLIGHTED_TEXT:
        'Includes {{ discount }} Direct Debit Discount',
      PAYMENT_METHOD_DIRECT_DEBIT_OPTION_LABEL: 'Direct debit',
      PAYMENT_METHOD_ERROR_REQUIRED: 'Please select a payment method',
      PAYMENT_METHOD_FORM_SUBMIT_BUTTON: 'Continue to payment details',
      PAYMENT_METHOD_LABEL: 'Select your payment method',
      PAYMENT_METHOD_MONTHLY_LABEL: '12 monthly payments of {{ value }}',
      PAYMENT_METHOD_ONE_OFF_LABEL: 'One-time payment of {{ value }}',
      PAYMENT_METHOD_TOTAL_COST: 'Total cost: {{ value }}',
    },
  };
